import React, { Component, Fragment } from 'react'

import DayPicker, { DateUtils } from 'react-day-picker'
import { formatDate, parseDate } from 'react-day-picker/moment'

import { ErrorContainer } from 'components/common'
import 'moment/locale/es'
import Message from 'components/message'

import { DayPickerResponsive } from '../styled'

class DatePickerResponsive extends Component {
  state = {
    from: this.props.value ? this.props.value.from : undefined,
    to: this.props.value ? this.props.value.to : undefined,
    enteredTo: this.props.value ? this.props.value.to : undefined
  }

  /**
   * This method will add a specific class to the first and the last day of each month.
   */
  componentDidUpdate() {
    ;[...document.querySelectorAll('.DayPicker-Month')].forEach(month => {
      const days = [...month.querySelectorAll('.DayPicker-Day:not(.DayPicker-Day--outside)')]
      const first = days.shift()
      const last = days.pop()
      first.classList.add('DayPicker-Day--first')
      last.classList.add('DayPicker-Day--last')
    })
  }

  isSelectingFirstDay(from, to, day) {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from)
    const isRangeSelected = from && to
    return !from || isBeforeFirstDay || isRangeSelected
  }

  handleDayClick = day => {
    const { from, to } = this.state

    if (this.isSelectingFirstDay(from, to, day)) {
      this.setState({ from: day, to: undefined, enteredTo: undefined }, () =>
        this.handleFromChange(day)
      )
    } else {
      this.setState({ to: day, enteredTo: day }, () => this.handleToChange(day))
    }
  }

  handleDayMouseEnter = day => {
    const { from, to } = this.state

    if (!this.isSelectingFirstDay(from, to, day)) {
      this.setState({ enteredTo: day })
    }
  }

  handleFromChange = from => {
    this.setState({ from })
    if (this.state.to && this.state.to < from) {
      this.setState({ to: from })
    }
  }

  handleToChange = to =>
    this.setState({ to, enteredTo: to }, () => {
      const { from, to } = this.state
      this.props.onChange({ from, to })
    })

  handleResetClick = () => {
    this.setState({ from: undefined, to: undefined, enteredTo: undefined })
  }

  render() {
    const { from, enteredTo } = this.state
    const modifiers = { start: from, end: enteredTo }

    const {
      value,
      toMonth,
      /*onChange,*/ locale,
      initialMonth,
      fromMonth,
      fromError,
      format,
      disabledDays,
      dayPickerProps
    } = this.props
    return (
      <DayPickerResponsive>
        <DayPicker
          ref={ref => (this.from = ref)}
          value={value}
          format={format}
          formatDate={formatDate}
          parseDate={parseDate}
          onDayClick={this.handleDayClick}
          onDayMouseEnter={this.handleDayMouseEnter}
          locale={locale}
          disabledDays={disabledDays}
          numberOfMonths={12}
          modifiers={modifiers}
          selectedDays={[from, { from, to: enteredTo }]}
          {...dayPickerProps}
          navbarElement={<Fragment />}
          fromMonth={fromMonth}
          toMonth={toMonth}
          initialMonth={initialMonth}
        />
        {fromError && (
          <ErrorContainer>
            <Message type="formInputError">{fromError}</Message>
          </ErrorContainer>
        )}
      </DayPickerResponsive>
    )
  }
}

export default DatePickerResponsive
